import { filter, type FilterListType } from '../../stores/filter';
import { get } from 'svelte/store';
import { SettingsApi } from '../components/Settings/SettingsApi';
import { type localStorageFilterType } from '../components/telematics/components/FilterByParameters/FilterManager';
import { api } from '../../stores/api';
import { z } from 'zod';

export const resetFilterQuery = () => {
    console.debug('resetFilterQuery: ', get(filter).jobsToBeCompleted.managerStorageKey);
    filter.update(f => {
        f.jobsToBeCompleted.queries = {};
        f.jobsToBeCompleted.quickSearch = '';
        return f;
    });

    let data: localStorageFilterType = {
        mainFilterData: {
            queries: {},
            related: [],
        },
        lastUsedFilterData: {
            queries: {},
            related: [],
            historyOfAddedKeys: [],
        },
        __inactiveQueriesKeys: [],
        __andOrSelection: 'and',
    };
    SettingsApi.setClientSettings<localStorageFilterType>(
        get(api),
        get(filter).jobsToBeCompleted.managerStorageKey || '',
        data,
        z.any()
    );
};

export const getFilterQuery = (filter: FilterListType) => {
    let queries = {};

    if (filter.quickSearch !== '') {
        let or = [];
        if (typeof filter.queries['address_attributes.city'] === 'undefined') {
            or.push({
                'address_attributes.city': {
                    $ilike: '%' + filter.quickSearch + '%',
                },
            });
        }
        if (typeof filter.queries['address_attributes.street'] === 'undefined') {
            or.push({
                'address_attributes.street': {
                    $ilike: '%' + filter.quickSearch + '%',
                },
            });
        }
        if (typeof filter.queries['ext_id'] === 'undefined') {
            or.push({ ext_id: { $ilike: '%' + filter.quickSearch + '%' } });
        }
        if (typeof filter.queries['full_name'] === 'undefined') {
            or.push({
                full_name: { $ilike: '%' + filter.quickSearch + '%' },
            });
        }
        if (typeof filter.queries['address_attributes.pcode'] === 'undefined') {
            or.push({
                'address_attributes.pcode': {
                    $ilike: '%' + filter.quickSearch + '%',
                },
            });
        }
        if (Object.keys(filter.queries).length > 0) {
            if (filter.onlyLowQuality) {
                queries = {
                    $and: [filter.queries, { coords_accepted: false }, { $or: or }],
                };
            } else {
                queries = { $and: [filter.queries, { $or: or }] };
            }
        } else {
            if (filter.onlyLowQuality) {
                queries = { $and: [{ coords_accepted: false }, { $or: or }] };
            } else {
                queries = { $or: or };
            }
        }
    } else {
        if (filter.onlyLowQuality) {
            queries = { ...filter.queries, coords_accepted: false } || {};
        } else {
            queries = filter.queries || {};
        }
    }

    return queries;
};
